import { Paths } from '@config/paths.config';
import { ProductOrigin } from './product-origin.model';

export type SuggestionOriginChannel = 'suggestion' | 'suggestion_cart';

/**
 * Suggestions added from the cart page (`/cart`) are tagged `suggestion_cart`.
 * The funnel (`/cart/funnel`) and product-add child routes stay `suggestion`.
 */
export function suggestionChannelForUrl(url: string): SuggestionOriginChannel {
  const path = url.split(/[?#]/)[0].replace(/\/+$/, '');
  const segments = path.split('/').filter(Boolean);
  return segments.at(-1) === Paths.Cart ? 'suggestion_cart' : 'suggestion';
}

export function suggestionProductOrigin(
  url: string,
  reference: `suggestion_set_${string}`,
): Extract<ProductOrigin, { channel: SuggestionOriginChannel }> {
  const channel = suggestionChannelForUrl(url);
  if (channel === 'suggestion_cart') {
    return { channel, reference };
  }
  return { channel, reference };
}
